<script setup>
import { defineComponent } from 'vue'
import {useRoute} from "vue-router";
import Redirect from "@/components/Redirect.vue";
const route = useRoute()
defineComponent({
  name: 'SuccesAchatQRCode',
})
</script>

<template>
  <div class="text-center container">
    <h1>Achat terminé</h1>
    <h3 class="my-5">Merci pour votre achat</h3>
    <p>Votre commande n° {{route.query.numeroCommande}} a été enregistrée.</p>
    <p>
      Un email vient de vous être envoyé contenant le QR code représentant votre ticket électronique.<br/>
      Conservez-le précieusement, vous devrez le présenter au conducteur lors de votre montée !
    </p>
    <img width="30%" :src="route.query.qrCodeUrl" alt="QRcode"/>
    <Redirect/>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/main";

img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3rem;
  @media (max-width: 576px) {
    width: 30%;
  }
}
</style>
